/**
 * Whether a stored phone number is SMS-capable, for display only (e.g. the Preparer Roster's
 * optional "SMS-capable" column). This is NOT a carrier/line-type lookup -- the fleet has no
 * Twilio Lookup integration anywhere (confirmed by grep across api/Services/TwilioService.cs
 * before building this), so there is no way to tell a mobile number from a landline. What this
 * checks is the same precondition `TwilioService.NormalizePhoneNumber` relies on to produce a
 * valid US E.164 number: a 10-digit US number, with or without a leading country-code 1. A number
 * that fails this check could not be sent an SMS by this app's own outbound code path today,
 * whatever the real line type is; a number that passes it might still be a landline -- "capable"
 * means "shaped like a number we could attempt to text," not "verified mobile."
 */
export function isSmsCapablePhone(phone: string | null | undefined): boolean {
  if (!phone) return false;
  const digits = phone.replace(/\D/g, '');
  if (digits.length === 10) return true;
  if (digits.length === 11 && digits.startsWith('1')) return true;
  return false;
}
